import React from 'react'

const mountNode = document.getElementById('root')

if (mountNode !== null) {
  const { render } = require('react-dom')
  const Main = require('./editor/container/Main').default(window.__INITIAL_STATE__)

  render(Main, mountNode)
} else {
  // Load LESS
  require('./styles/import.less')

  const jQuery = window.jQuery = window.$ = require('jquery')

  require('jquery-ui')

  require('bootstrap')

  const CodeMirror = window.CodeMirror = require('codemirror')

  require('codemirror/addon/hint/show-hint')
  require('codemirror/addon/hint/xml-hint')
  require('codemirror/addon/hint/html-hint')
  require('codemirror/addon/edit/closetag')
  require('codemirror/mode/xml/xml')
  require('codemirror/mode/htmlmixed/htmlmixed')

  require('jquery-ui-touch-punch')
  require('slick-carousel')
  require('typed.js')

  require('./assets/js/all')

  require('./assets/js/faq')
  require('./assets/js/getting_started')
  require('./assets/js/index')
  require('./assets/js/templates-2016')
  require('./assets/js/download')
  require('./assets/js/components')
  require('./assets/js/community')
  require('./assets/js/api-landing')
}
